/* eslint-disable prefer-rest-params */
import concaveman from 'concaveman'
import { removeArrayDuplicates as removeDuplicates } from '@utils/removeArrayDuplicates'
import { getCirclePath } from '@utils/getCirclePath'
import COLORS from '@colors'

export default class Map {
  constructor(props) {
    const { map, maps } = props
    this.map = map
    this.maps = maps
    this.clusterExists = false
    this.geocoder = new this.maps.Geocoder()
    this.polygons = []
    this.loadedNeighborhoods = {}
    this.selectedPolygon = undefined
    this.isSelectingPolygon = false
    this.loadedZones = {}
    this.freehandListener = null
    this.drawingManager = new this.maps.drawing.DrawingManager({
      drawingControl: false,
      polygonOptions: {
        editable: false,
      },
      polylineOptions: {
        clickable: false,
      },
    })

    this.drawingManager.setMap(this.map)

    this.maps.event.addListener(
      this.drawingManager,
      'polygoncomplete',
      this.stopDrawingManager,
    )

    this.enableMapMovement()

    // NOTE define polygon getBounds
    if (!this.maps.Polygon.prototype.getBounds) {
      this.maps.Polygon.prototype.getBounds = function() {
        let bounds = new maps.LatLngBounds()
        this.getPath().forEach(function(element, index) {
          bounds.extend(element)
        })
        return bounds
      }
    }

    //GetBounds for containsLatLng
    if (!this.maps.Polygon.prototype.getBoundsForRT) {
      this.maps.Polygon.prototype.getBoundsForRT = function(latLng) {
        let bounds = new this.maps.LatLngBounds(),
          paths = this.getPaths(),
          path,
          p,
          i

        for (p = 0; p < paths.getLength(); p++) {
          path = paths.getAt(p)
          for (i = 0; i < path.getLength(); i++) {
            bounds.extend(path.getAt(i))
          }
        }

        return bounds
      }
    }

    // Polygon containsLatLng - method to determine if a latLng is within a polygon
    this.maps.Polygon.prototype.containsLatLng = function(latLng) {
      // Exclude points outside of bounds as there is no way they are in the poly

      let inPoly = false,
        bounds,
        lat,
        lng,
        numPaths,
        p,
        path,
        numPoints,
        i,
        j,
        vertex1,
        vertex2

      // Arguments are a pair of lat, lng variables
      if (arguments.length === 2) {
        if (
          typeof arguments[0] == 'number' &&
          typeof arguments[1] == 'number'
        ) {
          lat = arguments[0]
          lng = arguments[1]
        }
      } else if (arguments.length === 1) {
        bounds = this.getBoundsForRT()

        if (!bounds && !bounds.contains(latLng)) {
          return false
        }
        lat = latLng.lat()
        lng = latLng.lng()
      } else {
        console.log(
          'Wrong number of inputs in this.maps.Polygon.prototype.contains.LatLng',
        )
      }

      // Raycast point in polygon method

      numPaths = this.getPaths().getLength()
      for (p = 0; p < numPaths; p++) {
        path = this.getPaths().getAt(p)
        numPoints = path.getLength()
        j = numPoints - 1

        for (i = 0; i < numPoints; i++) {
          vertex1 = path.getAt(i)
          vertex2 = path.getAt(j)

          if (
            (vertex1.lng() < lng && vertex2.lng() >= lng) ||
            (vertex2.lng() < lng && vertex1.lng() >= lng)
          ) {
            if (
              vertex1.lat() +
                ((lng - vertex1.lng()) / (vertex2.lng() - vertex1.lng())) *
                  (vertex2.lat() - vertex1.lat()) <
              lat
            ) {
              inPoly = !inPoly
            }
          }

          j = i
        }
      }

      return inPoly
    }

    if (props.mobile) {
      this.mouseDownEvent = 'touchstart'
    } else {
      this.mouseDownEvent = 'mousedown'
    }
  }

  stopDrawingManager = polygon => {
    this.stopDrawing()
    this.savePolygon(polygon)
  }

  changeToRoadmapView() {
    this.map.setMapTypeId('roadmap')
  }

  changeToSatelliteView() {
    this.map.setMapTypeId('satellite')
  }

  decodePath(path) {
    return this.maps.geometry.encoding.decodePath(path)
  }

  encodePath(path) {
    return this.maps.geometry.encoding.encodePath(path)
  }

  clearClusters() {
    this.clusterExists = false
  }

  createLatLng({ lat, lng }) {
    return new this.maps.LatLng({ lat, lng })
  }

  initializeStreetView = (fenway, divId) => {
    const streetViewService = new this.maps.StreetViewService()
    const panorama = new this.maps.StreetViewPanorama(
      document.getElementById(divId),
      {
        position: fenway,
        pov: {
          heading: 165,
          pitch: 10,
          zoom: 1,
        },
      },
    )
    const processSVData = (data, status) => {
      if (status === this.maps.StreetViewStatus.OK) {
        panorama.setPano(data.location.pano)
        panorama.setPov({
          heading: 270,
          pitch: 0,
        })
        panorama.setVisible(true)
      } else {
        console.error('Street View data not found for this location.')
      }
    }

    streetViewService.getPanorama(
      {
        location: fenway,
        radius: 50,
        source: this.maps.StreetViewSource.OUTDOOR,
      },
      processSVData,
    )
    return panorama
  }

  clearPolygons() {
    if (this.polygons.length > 0) {
      this.polygons.forEach(polygon => {
        polygon.setVisible(false)
      })
      this.polygons = []
    }
  }

  createCircle = (center, radius = 250, getPath = false) => {
    const circle = new this.maps.Circle({
      strokeColor: COLORS.gray28,
      strokeOpacity: 0.8,
      strokeWeight: 2,
      fillColor: COLORS.gray28,
      fillOpacity: 0.35,
      map: this.map,
      isCircle: true,
      center,
      radius,
    })
    if (!getPath) {
      this.clearMap()
      this.savePolygon(circle)
    }
    return getCirclePath(circle, this.maps)
  }

  clearMap() {
    for (const cityId in this.loadedNeighborhoods) {
      if (this.loadedNeighborhoods.hasOwnProperty(cityId)) {
        this.hideNeighborhoods(cityId)
      }
    }
    for (const cityId in this.loadedZones) {
      if (this.loadedZones.hasOwnProperty(cityId)) {
        this.hideZones(cityId)
      }
    }
    this.clearPolygons()
  }

  createGeometryFromPath(path) {
    const options = {
      strokeColor: COLORS.gray28,
      fillColor: COLORS.gray28,
      fillOpacity: 0.1,
      strokeWeight: 2,
    }

    const polygon = this.createPolygonFromPath({ path }, options)
    polygon.setMap(this.map)
    polygon.setVisible(true)

    this.savePolygon(polygon)

    const latLng = polygon
      .getBounds()
      .getCenter()
      .toJSON()
    return latLng
  }

  createPolygonFromPath = (polygon, options, callback = null) => {
    const { name, path, id } = polygon
    const poly = new this.maps.Polygon({
      ...options,
      polyId: id,
      htmlContent: name,
      path: (!Array.isArray(path) && this.decodePath(path)) || path,
    })

    if (name) {
      const latLng = poly
        .getBounds()
        .getCenter()
        .toJSON()
      this.addDefaultListenersToPolygon(poly, latLng, callback)
    }

    return poly
  }

  addDefaultListenersToPolygon(polygon, latLng, callback = null) {
    polygon.infoWindow = new this.maps.InfoWindow({
      disableAutoPan: true,
      pixelOffset: {
        height: -10,
        width: 0,
      },
      content: polygon.htmlContent,
    })
    this.maps.event.addListener(polygon, 'mouseover', () => {
      polygon.setOptions({ fillOpacity: 0.2 })
      polygon.infoWindow.setPosition(latLng)
      polygon.infoWindow.open(this.map)
    })

    this.maps.event.addListener(polygon, 'mouseout', () => {
      polygon.setOptions({ fillOpacity: 0.1 })
      polygon.infoWindow.close()
    })

    this.maps.event.addListener(polygon, 'click', event => {
      callback?.start()
      if (this.selectedPolygon !== polygon) {
        this.selectedPolygon &&
          this.selectedPolygon.setOptions({
            strokeColor: COLORS.gray28,
            fillColor: COLORS.gray28,
            fillOpacity: 0.1,
            strokeWeight: 2,
          })
        polygon.setOptions({
          strokeColor: COLORS.leather,
          fillColor: COLORS.leather,
          fillOpacity: 0.1,
          strokeWeight: 5,
        })
        this.selectedPolygon = polygon
      } else {
        polygon.setOptions({
          strokeColor: COLORS.gray28,
          fillColor: COLORS.gray28,
          fillOpacity: 0.1,
          strokeWeight: 2,
        })
        this.selectedPolygon = undefined
        callback?.cancel()
      }
      this.isSelectingPolygon = this.selectedPolygon !== undefined
    })
  }

  createPolygon = path =>
    new this.maps.Polygon({
      clickable: false,
      strokeOpacity: 1,
      strokeWeight: 2,
      strokeColor: COLORS.gray28,
      fillColor: COLORS.gray28,
      fillOpacity: 0.1,
      path,
    })

  stopSelecting = () => {
    this.clearMap()
    this.selectedPolygon.setOptions({
      strokeColor: COLORS.gray28,
      fillColor: COLORS.gray28,
      fillOpacity: 0.1,
      strokeWeight: 2,
    })
    this.savePolygon(
      new this.maps.Polygon({
        map: this.map,
        clickable: false,
        strokeOpacity: 1,
        strokeWeight: 2,
        strokeColor: COLORS.gray28,
        fillColor: COLORS.gray28,
        fillOpacity: 0.1,
        path: this.selectedPolygon.getPath(),
      }),
    )
    this.isSelectingPolygon = false
  }

  cancelSelecting = () => {
    this.selectedPolygon?.setOptions({
      strokeColor: COLORS.gray28,
      fillColor: COLORS.gray28,
      fillOpacity: 0.1,
      strokeWeight: 2,
    })
    this.isSelectingPolygon = false
    this.selectedPolygon = undefined
  }

  drawPolygon() {
    this.clearMap()
    this.drawingManager.setDrawingMode(this.maps.drawing.OverlayType.POLYGON)
  }

  drawFreeHand() {
    this.clearMap()
    this.map.setOptions({ draggableCursor: 'crosshair' })
    this.freehandListener = this.maps.event.addDomListener(
      this.map.getDiv(),
      this.mouseDownEvent,
      event => {
        if (!event.ctrlKey) {
          this.disableMapMovement()
          this.map.setOptions({ draggableCursor: 'crosshair' })
        } else {
          this.enableMapMovement()
        }
        let polyLine = new this.maps.Polyline({
          map: this.map,
          clickable: false,
          strokeColor: COLORS.gray28,
          strokeOpacity: 1,
        })

        const move = this.maps.event.addListener(
          this.map,
          'mousemove',
          event => {
            polyLine.getPath().push(event.latLng)
          },
        )

        this.maps.event.addListenerOnce(this.map, 'mouseup', event => {
          this.maps.event.removeListener(move)
          this.drawingManager.setDrawingMode(null)
          this.stopDrawing()
          polyLine.setMap(null)

          const path = polyLine.getPath()
          const pathArray = path
            .getArray()
            .map(item => [item.lat(), item.lng()])

          if (pathArray.length) {
            path.clear()
            concaveman(pathArray).forEach(item =>
              path.push(
                new this.maps.LatLng({
                  lat: Number(item[0].toFixed(5)),
                  lng: Number(item[1].toFixed(5)),
                }),
              ),
            )
          }

          this.savePolygon(
            new this.maps.Polygon({
              map: this.map,
              clickable: false,
              strokeOpacity: 1,
              strokeColor: COLORS.gray28,
              fillColor: COLORS.gray28,
              fillOpacity: 0.1,
              path,
            }),
          )
        })
      },
    )
  }

  toggleMapMovement = () => {
    if (this.map.draggable) {
      this.disableMapMovement()
    } else {
      this.enableMapMovement()
    }
  }

  disableMapMovement = () => {
    this.map.setOptions({
      draggable: false,
      zoomControl: false,
      scrollwheel: false,
    })
  }

  enableMapMovement = () => {
    this.map.setOptions({
      draggable: true,
      draggableCursor: 'default',
      zoomControl: true,
      scrollwheel: true,
    })
  }

  getPolygons() {
    return this.polygons
  }

  getPolygonsAsArray() {
    let closedPolygonsArray = this.getPolygons().map(polygon => {
      let polygonsArray = removeDuplicates(
        polygon.getRadius
          ? getCirclePath(polygon, this.maps).map(item => [
              item.lng(),
              item.lat(),
            ])
          : polygon
              .getPath()
              .getArray()
              .map(item => [item.lng(), item.lat()]),
      )
      if (
        polygonsArray.length > 1 &&
        polygonsArray[0].toString() !==
          polygonsArray[polygonsArray.length - 1].toString()
      ) {
        polygonsArray.push(polygonsArray[0])
      }
      return polygonsArray
    })
    return closedPolygonsArray
  }

  geocode(address, callback) {
    this.geocoder.geocode(
      {
        address,
        componentRestrictions: {
          country: 'BR',
        },
        region: 'BR',
        language: 'pt-BR',
      },
      callback,
    )
  }

  hideNeighborhoods(cityId) {
    this.loadedNeighborhoods[cityId] &&
      this.loadedNeighborhoods[cityId].forEach(neighborhood => {
        neighborhood.setVisible(false)
      })
  }

  hideZones(cityId) {
    this.loadedZones[cityId] &&
      this.loadedZones[cityId].forEach(zone => {
        zone.setVisible(false)
      })
  }

  loadNeighborhoods(neighborhoods, onClick, cityId) {
    const options = {
      strokeOpacity: 1,
      strokeWeight: 2,
      fillOpacity: 0.1,
      strokeColor: COLORS.gray28,
      fillColor: COLORS.gray28,
    }
    if (!this.loadedNeighborhoods[cityId])
      this.loadedNeighborhoods[cityId] = neighborhoods.map(neighborhood =>
        this.createPolygonFromPath(neighborhood, options, onClick),
      )
  }

  addPolygonFromPath = path => {
    const options = {
      strokeOpacity: 1,
      strokeWeight: 2,
      fillOpacity: 0.1,
      strokeColor: COLORS.gray28,
      fillColor: COLORS.gray28,
    }
    const polygon = this.createPolygonFromPath(path, options)

    this.resetMap()
    polygon.setMap(this.map)
    polygon.setVisible(true)
    this.savePolygon(polygon)
  }

  loadZones(zones, onClick, cityId) {
    const options = {
      strokeOpacity: 1,
      strokeWeight: 2,
      fillOpacity: 0.1,
      strokeColor: COLORS.gray28,
      fillColor: COLORS.gray28,
    }
    this.loadedZones[cityId] = zones.map(zone =>
      this.createPolygonFromPath(zone, options, onClick),
    )
  }

  renderNeighborhoods(cityId) {
    this.loadedNeighborhoods[cityId] &&
      this.loadedNeighborhoods[cityId].forEach(neighborhood => {
        if (!neighborhood.getMap()) {
          neighborhood.setMap(this.map)
        }
        neighborhood.setVisible(true)
      })
  }

  getMaps() {
    return this.maps
  }

  renderZones(cityId) {
    this.loadedZones[cityId] &&
      this.loadedZones[cityId].forEach(zone => {
        if (!zone.getMap()) {
          zone.setMap(this.map)
        }
        zone.setVisible(true)
      })
  }

  savePolygon = polygon => {
    this.polygons.push(polygon)
  }

  stopDrawing() {
    this.freehandListener &&
      this.maps.event.removeListener(this.freehandListener)
    this.maps.event.clearListeners(this.map.getDiv(), this.mouseDownEvent)
    this.drawingManager.setDrawingMode(null)
    this.enableMapMovement()
  }

  selectPolygon = (polygonId, cityId, polygonType = 'neighborhood') => {
    this.selectedPolygon = (polygonType === 'zoning'
      ? this.loadedZones[cityId]
      : this.loadedNeighborhoods[cityId]
    ).filter(item => item.polyId === polygonId)[0]
    this.stopSelecting()
  }

  resetMap(options) {
    this.clearMap()
    this.enableMapMovement()
    this.selectedPolygon = undefined
    if (options?.cityId) {
      options?.neighborhoods && this.renderNeighborhoods(options.cityId)
      options?.zones && this.renderZones(options.cityId)
    }
  }
}
